import * as React from "react";

export const SvgWarningSolid = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M10 2a8 8 0 1 0 8 8 8.016 8.016 0 0 0-8-8Zm-.615 4.308a.615.615 0 1 1 1.23 0v4.307a.615.615 0 1 1-1.23 0V6.308Zm.615 8a.923.923 0 1 1 0-1.845.923.923 0 0 1 0 1.845Z"
			fill={props.color ?? "#A8A8A8"}
		/>
	</svg>
);
